import type { RoomMemberEntity } from '@/helpers/types'
import { useMemberState } from '@/hooks/useMemberState'
import { useRoomStore } from '@/stores/room'

interface UseSelfMemberStateProps<TKey> {
  subscriptionKey: TKey
}

export const useSelfMemberState = <
  TKey extends NonNullable<keyof RoomMemberEntity>,
>({
  subscriptionKey,
}: UseSelfMemberStateProps<TKey>): RoomMemberEntity[TKey] => {
  const memberId = useRoomStore(state => state.memberId)

  const selfMemberStateSlice = useMemberState({
    memberId: memberId,
    subscriptionKey: subscriptionKey,
  })

  return selfMemberStateSlice
}
